export default function AboutHero() {
  return (
    <section className="relative h-[480px] md:h-[580px] flex items-end pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=grand%20Victorian%20heritage%20furniture%20workshop%20Rawalpindi%20Pakistan%20colonial%20era%20ornate%20carved%20mahogany%20showroom%20interior%20warm%20amber%20candlelight%20golden%20atmospheric%20regal%20antique%20wooden%20furniture%20legacy%20rich%20textures%20dark%20warm%20sepia%20tones%20beautiful%20premium%20craftsmanship&width=1920&height=700&seq=abouthero_v3&orientation=landscape"
          alt="About M. Hayat & Co. — Heritage Since 1870"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-darkbrown/90 via-brand-darkbrown/50 to-brand-darkbrown/20" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-10 bg-brand-gold" />
          <span className="font-display text-brand-gold text-[10px] tracking-[5px] uppercase">
            Est. 1870 &middot; Rawalpindi, Pakistan
          </span>
        </div>
        <h1 className="font-serif text-5xl md:text-7xl text-white font-bold leading-tight mb-4">
          Our <em>Story</em>
        </h1>
        <p className="font-sans text-white/65 text-sm max-w-xl leading-relaxed">
          From a modest workshop in Jhelum to the Official Cabinet Makers of the President of Pakistan —
          over 150 years of craftsmanship, legacy, and living heritage.
        </p>
      </div>
    </section>
  );
}
